import { capitalizeWords, formatStringWithUnderscore } from '../../../../../../../helpers/common'

export const onScreenPositionOptions = [
  {
    name: 'targetingTypes/TARGETING_TYPE_ON_SCREEN_POSITION/targetingOptions/21',
    targetingOptionId: '21',
    targetingType: 'TARGETING_TYPE_ON_SCREEN_POSITION',
    onScreenPositionDetails: {
      onScreenPosition: 'ON_SCREEN_POSITION_ABOVE_THE_FOLD'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_ON_SCREEN_POSITION/targetingOptions/22',
    targetingOptionId: '22',
    targetingType: 'TARGETING_TYPE_ON_SCREEN_POSITION',
    onScreenPositionDetails: {
      onScreenPosition: 'ON_SCREEN_POSITION_BELOW_THE_FOLD'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_ON_SCREEN_POSITION/targetingOptions/23',
    targetingOptionId: '23',
    targetingType: 'TARGETING_TYPE_ON_SCREEN_POSITION',
    onScreenPositionDetails: {
      onScreenPosition: 'ON_SCREEN_POSITION_UNKNOWN'
    }
  }
]

export const formattedOnScreenPositionOptions = onScreenPositionOptions.map(option => {
  const value = option.onScreenPositionDetails.onScreenPosition
  const label = capitalizeWords(formatStringWithUnderscore(value.split('ON_SCREEN_POSITION_')[1].toLowerCase()))

  return {
    label,
    value,
    targetingOptionId: option.targetingOptionId
  }
})

export const contentInstreamPositionOptions = [
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_INSTREAM_POSITION/targetingOptions/509201',
    targetingOptionId: '509201',
    targetingType: 'TARGETING_TYPE_CONTENT_INSTREAM_POSITION',
    contentInstreamPositionDetails: {
      contentInstreamPosition: 'CONTENT_INSTREAM_POSITION_PRE_ROLL'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_INSTREAM_POSITION/targetingOptions/509202',
    targetingOptionId: '509202',
    targetingType: 'TARGETING_TYPE_CONTENT_INSTREAM_POSITION',
    contentInstreamPositionDetails: {
      contentInstreamPosition: 'CONTENT_INSTREAM_POSITION_MID_ROLL'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_INSTREAM_POSITION/targetingOptions/509203',
    targetingOptionId: '509203',
    targetingType: 'TARGETING_TYPE_CONTENT_INSTREAM_POSITION',
    contentInstreamPositionDetails: {
      contentInstreamPosition: 'CONTENT_INSTREAM_POSITION_POST_ROLL'
    }
  }
]

export const formattedContentInstreamPositionOptions = contentInstreamPositionOptions.map(option => {
  const value = option.contentInstreamPositionDetails.contentInstreamPosition
  const label = capitalizeWords(formatStringWithUnderscore(value.split('CONTENT_INSTREAM_POSITION_')[1].toLowerCase()))

  return {
    label,
    value,
    targetingOptionId: option.targetingOptionId
  }
})

export const contentOutstreamPositionOptions = [
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION/targetingOptions/509500',
    targetingOptionId: '509500',
    targetingType: 'TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION',
    contentOutstreamPositionDetails: {
      contentOutstreamPosition: 'CONTENT_OUTSTREAM_POSITION_UNKNOWN'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION/targetingOptions/509501',
    targetingOptionId: '509501',
    targetingType: 'TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION',
    contentOutstreamPositionDetails: {
      contentOutstreamPosition: 'CONTENT_OUTSTREAM_POSITION_IN_ARTICLE'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION/targetingOptions/509502',
    targetingOptionId: '509502',
    targetingType: 'TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION',
    contentOutstreamPositionDetails: {
      contentOutstreamPosition: 'CONTENT_OUTSTREAM_POSITION_IN_BANNER'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION/targetingOptions/509503',
    targetingOptionId: '509503',
    targetingType: 'TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION',
    contentOutstreamPositionDetails: {
      contentOutstreamPosition: 'CONTENT_OUTSTREAM_POSITION_IN_FEED'
    }
  },
  {
    name: 'targetingTypes/TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION/targetingOptions/509504',
    targetingOptionId: '509504',
    targetingType: 'TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION',
    contentOutstreamPositionDetails: {
      contentOutstreamPosition: 'CONTENT_OUTSTREAM_POSITION_INTERSTITIAL'
    }
  }
]

export const formattedContentOutstreamPositionOptions = contentOutstreamPositionOptions.map(option => {
  const value = option.contentOutstreamPositionDetails.contentOutstreamPosition
  const label = capitalizeWords(formatStringWithUnderscore(value.split('CONTENT_OUTSTREAM_POSITION_')[1].toLowerCase()))

  return {
    label,
    value,
    targetingOptionId: option.targetingOptionId
  }
})
